import { createContext, PropsWithChildren, useEffect, useState } from "react"
import { ensurePosthogInitialized, posthog } from "../analytics/posthogClient.web"

type ProviderProps = PropsWithChildren

const Context = createContext<typeof posthog | undefined>(undefined)

function PosthogProvider(props: ProviderProps) {
  const { children } = props
  const [initialized, setInitialized] = useState(false)

  useEffect(() => {
    ensurePosthogInitialized()
    setInitialized(true)

    return () => posthog.reset()
  }, [])

  return <Context.Provider value={initialized ? posthog : undefined}>{children}</Context.Provider>
}

export default PosthogProvider
